/**
 * Calibration wizard math — a faithful port of the prototype's schedule
 * (reference/SpeedReaderv2.html handleCalibrationChoice): 250 WPM baseline,
 * coarse-to-fine adjustment (every value lands on a 25-WPM step), at most 3
 * rounds, "just right" ends immediately. Skip sets 300.
 */

export const CALIBRATION_BASELINE_WPM = 250;
export const CALIBRATION_SKIP_WPM = 300;
export const CALIBRATION_MAX_ROUNDS = 3;

export type CalibrationChoice = 'right' | 'slow' | 'fast' | 'faster';

export interface CalibrationState {
  readonly wpm: number;
  /** 0-based round of the sample just played. */
  readonly round: number;
  readonly done: boolean;
}

export const CALIBRATION_START: CalibrationState = {
  wpm: CALIBRATION_BASELINE_WPM,
  round: 0,
  done: false,
};

export function calibrationStep(
  state: CalibrationState,
  choice: CalibrationChoice,
): CalibrationState {
  if (state.done) return state;
  if (choice === 'right') return { ...state, done: true };

  let wpm = state.wpm;
  if (choice === 'slow') wpm = Math.min(1200, state.wpm + (state.round === 0 ? 150 : 75));
  else if (choice === 'fast') wpm = Math.max(100, state.wpm - (state.round === 0 ? 100 : 50));
  else wpm = Math.min(1200, state.wpm + 50); // 'faster' — offered after round 0

  const round = state.round + 1;
  return { wpm, round, done: round >= CALIBRATION_MAX_ROUNDS };
}
